import useCustomMutation from "@/hooks/useCustomMutation";
import Modal from "@shared/Modal/Modal";
import { FONTS } from "@/constants/Fonts/fonts";
import { FONT_SIZES } from "@/constants/Fonts/font_sizes";
import ColorButton from "@shared/Buttons/ColorButton/ColorButton";
import Row from "@shared/Layout/Row/Row";
import { Typography } from "@mui/material";

export default function useDeleteCode({ id, onSettled, lang }) {
  const { mutate, isPending } = useCustomMutation({
    url: `code/deletePaymentCode?paymentCode_id=${id}`,
    invalidate: [["code", id], "code"],
    method: "delete",
    successMsg:
      lang == "ar"
        ? "تم حذف الكود بنجاح"
        : "The code has been successfully deleted",
    onSettled,
    lang,
  });

  function deleteCode() {
    mutate();
  }

  return { deleteCode, isPending };
}

export function DeleteCode({ courseId }) {
  const { deleteCode, isPending } = useDeleteCode({
    id: courseId,
    onSettled: () => {
      setOpen(false);
      setActiveCode(null);
      refetch();
    },
  });
  return (
    <Modal open={open} closeFn={() => setOpen(false)} maxWidth={"sm"}>
      <Typography fontFamily={FONTS.BOLD} fontSize={FONT_SIZES.LARGE}>
        {lang == "ar"
          ? "هل انت متأكد من حذف الكود؟"
          : "Are you sure to delete the code?"}
      </Typography>
      <Row mt={2} gap={2}>
        <ColorButton
          onClick={() => deleteCode()}
          //  {/* isLoading={isPending} */}
          colorType="danger"
          width="100px"
        >
          {lang == "ar" ? "حذف" : "Delete"}
        </ColorButton>
        <ColorButton
          colorType="secondary"
          width="100px"
          onClick={() => setOpen(false)}
        >
          {lang == "ar" ? "الغاء" : "Cancel"}
        </ColorButton>
      </Row>
    </Modal>
  );
}
